import {
  Box,
  Button,
  ButtonGroup,
  Heading,
  Input,
  SimpleGrid,
  Stack,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import parse from 'html-react-parser';

export const DoubleTheDonationCompanyInfo = ({ companyData }: any) => (
  <Box boxShadow="0 2px 4px 0 rgba(170,170,170,.5)" padding={4}>
    <Box pb={6}>
      <Input readOnly defaultValue={companyData?.company_name} />
    </Box>
    <Stack alignItems="center">
      {companyData?.matching_gift_offered ? (
        <VStack spacing={4}>
          <Text as="b" fontSize="lg">
            Yes! 👍
          </Text>
          <Text>Your company has a matching gift program.</Text>
          <Wrap
            as={ButtonGroup}
            spacing={4}
            justify="center"
            colorScheme="blue"
          >
            {companyData?.url_forms && (
              <WrapItem>
                <Button as="a" target="_blank" href={companyData.url_forms}>
                  Go to matching gift form
                </Button>
              </WrapItem>
            )}
            {companyData?.url_guidelines && (
              <WrapItem>
                <Button
                  as="a"
                  target="_blank"
                  href={companyData.url_guidelines}
                >
                  Link to Guidelines
                </Button>
              </WrapItem>
            )}
          </Wrap>
          <VStack spacing={6} py={4}>
            <Heading fontSize="xl">Match Amounts</Heading>
            <SimpleGrid
              columns={[null, null, 3]}
              spacing={12}
              alignItems="center"
              textAlign="center"
            >
              <Box bg="brand.primary.lightGrey" padding={4}>
                <Text>Maximum</Text>
                <Text as="b">{companyData?.maximum_matched}</Text>
              </Box>
              <Box bg="brand.primary.lightGrey" padding={4}>
                <Text>Minimum</Text>
                <Text as="b">{companyData?.minimum_matched}</Text>
              </Box>
              <Box bg="brand.primary.lightGrey" padding={4}>
                <Text>Match Ratio</Text>
                <Text as="b">{companyData?.ratio}</Text>
              </Box>
            </SimpleGrid>
          </VStack>
          <VStack spacing={6} py={4}>
            <Heading fontSize="xl">Employee Eligibility</Heading>
            <SimpleGrid
              columns={[null, null, 3]}
              spacing={12}
              alignItems="center"
              textAlign="center"
            >
              <Box bg="brand.primary.lightGrey" padding={4}>
                <Text>Full-Time Employees</Text>
                <Text as="b">
                  {companyData?.full_time_eligible ? 'Yes' : 'No'}
                </Text>
              </Box>
              <Box bg="brand.primary.lightGrey" padding={4}>
                <Text>Part-Time Employees</Text>
                <Text as="b">
                  {companyData?.part_time_eligible ? 'Yes' : 'No'}
                </Text>
              </Box>
              <Box bg="brand.primary.lightGrey" padding={4}>
                <Text>Retired Employees</Text>
                <Text as="b">
                  {companyData?.retirees_eligible ? 'Yes' : 'No'}
                </Text>
              </Box>
            </SimpleGrid>
          </VStack>
          <VStack spacing={4} maxW={['340px', '340px', 'full']}>
            <Heading fontSize="xl">Matching Gift Information</Heading>
            <VStack>{parse(companyData?.matching_gift_process ?? '')}</VStack>
          </VStack>
        </VStack>
      ) : (
        <VStack spacing={4}>
          <Text as="b" fontSize="lg">
            No!
          </Text>
          <Text>This employer does not have a matching gift program.</Text>
        </VStack>
      )}
      {!companyData?.volunteer_grant_offered && (
        <VStack spacing={6} py={4}>
          <Heading fontSize="xl">Volunteer Grants</Heading>
          <Text as="b">
            {companyData?.volunteer_grant_offered ? 'Yes' : 'No'}
          </Text>
          <SimpleGrid
            columns={[null, null, 2]}
            spacing={12}
            alignItems="center"
            textAlign="center"
          >
            <Box bg="brand.primary.lightGrey" padding={4}>
              <Text>Minimum Hours Required</Text>
              <Text as="b">
                {companyData?.volunteer_minimum_hours_required ? 'Yes' : 'No'}
              </Text>
            </Box>
            <Box bg="brand.primary.lightGrey" padding={4}>
              <Text>Corporate Donation</Text>
              <Text as="b">
                {companyData?.corporate_donation_offered ? 'Yes' : 'No'}
              </Text>
            </Box>
          </SimpleGrid>
          <VStack spacing={4} maxW={['340px', '340px', 'full']}>
            <Heading fontSize="xl">Volunteer Grant Information</Heading>
            <VStack align="stretch">
              {parse(companyData?.volunteer_grant_process ?? '')}
            </VStack>
          </VStack>
        </VStack>
      )}
      <VStack>
        <Heading fontSize="xl">Corporate Information</Heading>
        <Text>{companyData?.corporate_contact_name}</Text>
        <Text>{companyData?.corporate_contact_phone}</Text>
        <Text>{companyData?.corporate_contact_email}</Text>
      </VStack>
    </Stack>
  </Box>
);
